export const ACCOUNT_TYPE_LABELS = {
  HR_EU: "HR SPDR XAU",
  LR_XAU: "Low Risk XAU",
  SPDR_XAU: "SPDR XAU",
  EURUSDc: "EURUSDc",
  EURUSDcn: "EURUSDcn",
  EURUSDCN: "EURUSDcn",
  EURUSD_2: "EURUSD 2.0",
  EURUSD_3: "EURUSD 3.0",
  SM: "SM",
  XAUUSDc: "XAUUSDc",
  DIABLOKONG: "DiabloKong",
  JKW_XAU: "JKW XAU",
  JKW_24HR_XAU: "JKW 24HR XAU",
  CTC: "CTC",
  FTG: "FTG",
  OSOK: "OSOK",
  BTC: "BTC",
  BlueStar: "BlueStar",
  BTCMu: "BTCMu",
  DiabloMan: "DiabloMan",
  GBPJPY: "GBPJPY",
  JKW_3_XAU: "JKW 3.0 XAU",
  WOW: "WOW",
  Diablo: "Diablo",
  JKW24K: "JKW24K",
  BlueStar15: "BlueStar15",
  EURUSDc100: "EURUSDc100",
  DiabloBoi: "DiabloBoi",
  Buciblo: "Buciblo",
  Bucibloboi: "Bucibloboi",
  RJW88Slow: "RJW88Slow",
  RJW88Fast: "RJW88Fast",
  JKW88: "JKW88",
  BlueStar5: "BlueStar5",
  JKWRJWFAST: "JKWRJWFast",
};

export const ACCOUNT_TYPE_LOT_RULES = {
  EURUSDc: { min: 1, max: 10 },
  EURUSDcn: { min: 1, max: 10 },
  EURUSD_2: { min: 1, max: 10 },
  EURUSD_3: { min: 1, max: 500 },
  HR_EU: { min: 1, max: 13 },
  XAUUSDc: { min: 1, max: 3 },
  DIABLOKONG: { min: 1, max: 10 },
  LR_XAU: { min: 1, max: 7 },
  SPDR_XAU: { min: 1, max: 13 },
  JKW_XAU: { min: 1, max: 100 },
  JKW_24HR_XAU: { min: 1, max: 100 },
  SM: { min: 1, max: 100 },
  CTC: { min: 1, max: 100 },
  FTG: { min: 1, max: 500 },
  OSOK: { min: 1, max: 500 },
  JKW_3_XAU: { min: 1, max: 100 },
  WOW: { min: 1, max: 500 },
  Diablo: { min: 1, max: 500 },
  JKW24K: { min: 1, max: 100 },
  BlueStar15: { min: 1, max: 500 },
  JKWRJWFAST: { min: 1, max: 100 },
  EURUSDc100: { min: 1, max: 100 },
  DiabloMan: { min: 1, max: 100 },
  DiabloBoi: { min: 1, max: 100 },
  Buciblo: { min: 1, max: 100 },
  Bucibloboi: { min: 1, max: 10 },
  RJW88Slow: { min: 1, max: 100 },
  RJW88Fast: { min: 1, max: 100 },
  JKW88: { min: 1, max: 100 },
  BlueStar5: { min: 1, max: 500 },
  GBPJPY: { min: 1, max: 100 },
  BTC: { min: 1, max: 10 },
  BlueStar: { min: 1, max: 10 },
  BTCMu: { min: 1, max: 10 },
};

export const ACCOUNT_TYPE_OPTIONS = [
  { label: "EURUSDc", value: "EURUSDc" },
  { label: "EURUSDcn", value: "EURUSDcn" },
  { label: "EURUSD 2.0", value: "EURUSD_2" },
  { label: "EURUSD 3.0", value: "EURUSD_3" },
  { label: "DiabloKong", value: "DIABLOKONG" },
  { label: "XAUUSDc", value: "XAUUSDc" },
  { label: "Low Risk XAU", value: "LR_XAU" },
  { label: "JKW XAU", value: "JKW_XAU" },
  { label: "JKW 3.0 XAU", value: "JKW_3_XAU" },
  { label: "WOW", value: "WOW" },
  { label: "Diablo", value: "Diablo" },
  { label: "BlueStar", value: "BlueStar" },
  { label: "BlueStar5", value: "BlueStar5" },
  { label: "BlueStar15", value: "BlueStar15" },
  { label: "DiabloBoi", value: "DiabloBoi" },
  { label: "DiabloMan", value: "DiabloMan" },
  { label: "Buciblo", value: "Buciblo" },
  { label: "Bucibloboi", value: "Bucibloboi" },
  { label: "EURUSDc100", value: "EURUSDc100" },
  { label: "RJW88Slow", value: "RJW88Slow" },
  { label: "RJW88Fast", value: "RJW88Fast" },
  { label: "JKW88", value: "JKW88" },
  { label: "SM", value: "SM" },
  { label: "FTG", value: "FTG" },
  { label: "OSOK", value: "OSOK" },
  { label: "BTC", value: "BTC" },
  { label: "BTCMu", value: "BTCMu" },
  { label: "GBPJPY", value: "GBPJPY" },
];

const GOLD_VPS_ACCOUNT_TYPES = {
  XAUUSDc: true,
  XAUUSD: true,
  Buciblo: true,
};

const NON_GOLD_VPS_ACCOUNT_TYPES = {
  EURUSD: true,
  EURUSDc: true,
  EURUSDcn: true,
  HR_EU: true,
  DIABLOKONG: true,
  LR_XAU: true,
  SPDR_XAU: true,
  JKW_XAU: true,
  JKW_24HR_XAU: true,
  SM: true,
  CTC: true,
};

const getRegistryValue = (registry, type) => {
  if (!type) {
    return null;
  }

  if (registry[type]) {
    return registry[type];
  }

  const normalized = String(type).toUpperCase();
  const matchedKey = Object.keys(registry).find(
    (key) => key.toUpperCase() === normalized,
  );

  return matchedKey ? registry[matchedKey] : null;
};

export const getAccountTypeLabel = (type) =>
  getRegistryValue(ACCOUNT_TYPE_LABELS, type) || type;

export const getAccountTypeLotRule = (type) =>
  getRegistryValue(ACCOUNT_TYPE_LOT_RULES, type);

export const isGoldVpsAccountType = (type) =>
  Boolean(getRegistryValue(GOLD_VPS_ACCOUNT_TYPES, type));

export const isNonGoldVpsAccountType = (type) =>
  Boolean(getRegistryValue(NON_GOLD_VPS_ACCOUNT_TYPES, type));
